import React from "react";
import styled from "styled-components";
import { useQuery } from "@tanstack/react-query";
import { tmdbApi } from "../../services/tmdb";
import { MediaGrid } from "../media/MediaGrid";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { Sparkles } from "lucide-react";

const SuggestionsSection = styled.section`
  margin: var(--spacing-6) 0;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  margin-bottom: var(--spacing-4);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
`;

export const SearchSuggestions = () => {
  const { data: discoverData, isLoading } = useQuery({
    queryKey: ["discover", "movie"],
    queryFn: () => tmdbApi.getDiscover("movie"),
  });

  if (isLoading) return <LoadingSpinner />;
  if (!discoverData?.results?.length) return null;

  return (
    <SuggestionsSection>
      <Title>
        <Sparkles size={24} />
        Films populaires
      </Title>
      <MediaGrid items={discoverData.results.slice(0, 12)} type="movie" />
    </SuggestionsSection>
  );
};
